export const environment = {
  production: true,
  cloudUrl:'https://us-central1-rare-lambda-245821.cloudfunctions.net/TestApp/', // use for test side
      
      // domain:"https://api.fashin.us/",
      // domain:"http://apibtyb.ikaart.org/",
      // domain:'http://apifashion.ikaart.org/',
      // domain:'http://localhost:49937/',
      // domain:'http://apibuysell.ikaart.org/',
      // domain:'https://apibuysell.ikaart.in/',
      // domain:'https://apibliss.ikaart.in/',
      // domain:'https://api.blissls.com/',
          domain:'https://apibliss.ikaart.in/',
    Admin:{
      // Btyb start
      // PostAdminLogin:"api/Login/Login",
      // UserForgotPassword:"api/BTYB/ForGotPassword",
        // UserChangePassword:"api/BTYB/CreateUpdateUserMasterData",

        GetUserFilterBTYB:"",

        GetOrderMaster:'',
        PostAdminLoginBTYB:'',
        GetUserPostCommentsData:'',
        GetUserProductReviewData:'',
        UpdatePayOuttoStripeAccount:"",
        CreateUpdateUserPostCommentsData:'',
      // Btyb end

      //tattoo admin start
      PostAdminLoginTattoo:'api/Login/LoginAdmin',
      GetTattoArtistAdminData: 'api/Tatto/GetTattoArtistAdminData',
      CreateUpdateVideoMasterData:'api/Tatto/CreateUpdateVideoMasterData',
      GetVideoMasterData:'api/Tatto/GetVideoMasterData',

       //tattoo admin end

       //buysell
       CreateUpdateCategoryMasterData:'api/BuySell/CreateUpdateCategoryMasterData',
       CreateUpdateSubCategoryMasterData:'api/BuySell/CreateUpdateSubCategoryMasterData',  
       GetCategoryMasterData:'api/BuySell/GetCategoryMasterData',
       GetSubCategoryMasterData:'api/BuySell/GetSubCategoryMasterData',
       GetUserFilterBuysell:"api/BuySell/GetUserMasterData",
       GetAdminData:'api/BuySell/GetAdminData',
       GetUserPostData:'api/BuySell/GetUserPostData',
       GetUserFavorite:'api/BlissApi/GetUserFavorite',
       GetGarageMasterData:'api/BuySell/GetGarageMasterData',
       GetSubsribptionData:'api/BuySell/GetSubsribptionData',
       CreateUpdateUserSubscriptionData:'api/BuySell/CreateUpdateUserSubscriptionData',
       _getUserSubscriptionDetails:'',
       _createUpdateSubscription:'',
       CreateUpdateBrandMasterData:'api/BuySell/CreateUpdateBrandMasterData',
       GetBrandMasterData:'api/BuySell/GetBrandMasterData',
     
      //1)Login
      PostAdminLogin:"",
      UserForgotPassword:"",
      UserChangePassword:"",
      PostAdminUser:"",
      GetAdminProfileUser:"",

      //2)App User
      GetUserFilter:"",
      PostUser:"",
      //product-deetails
      AddUserAdminDetails:"",
         GetUserAdminDetails:"",
         GetUserAdminRoleDetails:"api/BuySell/GetUserAdminRole",
        //  getMenuRoleRelation:"api/BuySell/GetMenuRoleRelation",
        GetUsers:'api/BlissApi/GetUserMasterData',
        DeleteUserMaster:'api/BlissApi/DeleteUserMaster',
         getMenuRoleRelation:"api/BlissApi/GetMenuRoleRelation",
         CreateUpdateUserMasterData:"api/BlissApi/CreateUpdateUserMasterData",
         GetUserMasterAllData:"api/BlissApi/GetUserMasterAllData",
         GetUserBlock:"api/BlissApi/GetUserBlock",
         CreateUpdateUserBlock:"api/BlissApi/CreateUpdateUserBlock",
         GetUserMasterData:"api/BlissApi/GetUserMasterData",
         Admin_Data:"api/BlissApi/Admin_Data",


         CreateUpdate_User_Testimonial:'api/SuperProApi/CreateUpdateUserTestimonial',
         GetCountryMaster:'api/SuperProApi/GetCountryMaster',
         GetJobRoleMaster:'api/SuperProApi/GetJobRoleMaster',
         GetUserTestimonial:'api/SuperProApi/GetUserTestimonial',
         getMenu:"api/BuySell/GetMenuMaster",
         
         AddCollectionMaster:"",
         GetCollectionMaster:"",
         GetUserFollwers:"",
         AddUserCollection:"",
         GetUserCollection:"",
         GetUserPost:"",
         AddUserPost:"",
        //  GetSpotlightPost:"api/Fashion/",
        //  AddSpotlightPost:"api/Fashion/",
        GetDropDownCollection:"",
        ImageProductDetails:"",
        DropDownDetails:"",
    },
   
    // aws3ApiKey:{
    //   keyPrefix: "FASHIN/",
    //   bucketName:'fashindata',//'astagurubucket',
    //   //dirName:'',
    //   region:'us-west-2',
    //   accessKeyId:'AKIAYSWBYL27I6AW67BX',//'AKIASZESZFLPOPVEZFID',//'AKIATRTWCVISJ2432GMO',
    //   secretAccessKey:'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',//'HyhVTSY3Cd8q/BHgIAtHu2RpseK4sFoDqW69iI28',//'ZCqChiBiVvRxl8FJ75V47ysiP/iTUR2iKVRgDMZy',
    //   s3Url:'https://fashindata.s3.us-west-2.amazonaws.com/'//'https://astagurubucket.s3.ap-south-1.amazonaws.com/'
      
    // }
    aws3ApiKey:{
      // keyPrefix: "FASHIN/",
      bucketName:'starrbliss',//'astagurubucket',
      //dirName:'',
      region:'us-east-2',
      accessKeyId:'AKIAXZEFIESGN5W3D45E',//'AKIASZESZFLPOPVEZFID',//'AKIATRTWCVISJ2432GMO',
      secretAccessKey:'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',//'HyhVTSY3Cd8q/BHgIAtHu2RpseK4sFoDqW69iI28',//'ZCqChiBiVvRxl8FJ75V47ysiP/iTUR2iKVRgDMZy',
      s3Url:'https://starrbliss.us-east-2.amazonaws.com/'//'https://astagurubucket.s3.ap-south-1.amazonaws.com/'
      
    }
};
// export const environment = {
//   production: true,
//   cloudUrl:'https://us-central1-rare-lambda-245821.cloudfunctions.net/TestApp/', // use for test side
      
//       // domain:"https://api.fashin.us/",
//       domain:"http://apibtyb.ikaart.org/",
//       // domain:'http://apifashion.ikaart.org/',
//       // domain:'http://localhost:49937/',

//     Admin:{
//       // Btyb start
//       // PostAdminLogin:"api/Login/Login",
//       // UserForgotPassword:"api/BTYB/ForGotPassword",
//         // UserChangePassword:"api/BTYB/CreateUpdateUserMasterData",

//         GetUserFilterBTYB:"api/BTYB/GetUserMasterData",
//         GetUserPostData:'api/BTYB/GetUserPostData',
//         GetOrderMaster:'api/BTYB/GetOrderMaster',
//         PostAdminLoginBTYB:'api/Login/Login',
//         GetUserPostCommentsData:'api/BTYB/GetUserPostCommentsData',
//         GetUserProductReviewData:'api/BTYB/GetUserProductReviewData',
//         UpdatePayOuttoStripeAccount:"api/BTYB/UpdatePayOuttoStripeAccount",
//         CreateUpdateUserPostCommentsData:'api/BTYB/CreateUpdateUserPostCommentsData',
//       // Btyb end

//       //1)Login
//       PostAdminLogin:"",
//       UserForgotPassword:"",
//       UserChangePassword:"",
//       PostAdminUser:"",
//       GetAdminProfileUser:"",

//       //2)App User
//       GetUserFilter:"",
//       PostUser:"",
//       //product-deetails
//       AddUserAdminDetails:"",
//          GetUserAdminDetails:"",
//          GetUserAdminRoleDetails:"",
//          getMenuRoleRelation:"",
//          getMenu:"",
//          AddCollectionMaster:"",
//          GetCollectionMaster:"",
//          GetUserFollwers:"",
//          AddUserCollection:"",
//          GetUserCollection:"",
//          GetUserPost:"",
//          AddUserPost:"",
//         //  GetSpotlightPost:"api/Fashion/",
//         //  AddSpotlightPost:"api/Fashion/",
//         GetDropDownCollection:"",
//         ImageProductDetails:"",
//         DropDownDetails:"",
//     },
//     // aws3ApiKey:{
//     //   bucketName:'feelmotifiles',//'astagurubucket',
//     //   //dirName:'',
//     //   region:'ap-south-1',
//     //   accessKeyId:'AKIASZESZFLPJ42PLIOU',//'AKIASZESZFLPOPVEZFID',//'AKIATRTWCVISJ2432GMO',
//     //   secretAccessKey:'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',//'HyhVTSY3Cd8q/BHgIAtHu2RpseK4sFoDqW69iI28',//'ZCqChiBiVvRxl8FJ75V47ysiP/iTUR2iKVRgDMZy',
//     //   s3Url:'https://feelmotifiles.s3.ap-south-1.amazonaws.com/'//'https://astagurubucket.s3.ap-south-1.amazonaws.com/'
//     // }

//     aws3ApiKey:{
//       bucketName:'myfashionfiles',//'astagurubucket',
//       //dirName:'',
//       region:'ap-south-1',
//       accessKeyId:'AKIAYSWBYL27HDXJGZ7J',//'AKIASZESZFLPOPVEZFID',//'AKIATRTWCVISJ2432GMO',
//       secretAccessKey:'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',//'HyhVTSY3Cd8q/BHgIAtHu2RpseK4sFoDqW69iI28',//'ZCqChiBiVvRxl8FJ75V47ysiP/iTUR2iKVRgDMZy',
//       s3Url:'https://myfashionfiles.s3.ap-south-1.amazonaws.com/'//'https://astagurubucket.s3.ap-south-1.amazonaws.com/'
//     }
// };
